export enum CrmFieldFilterTypeEnum {
  DATE = 'date',
  DATETIME = 'datetime',
}


